(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authoritiesAll = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MODOP', 'ROLE_SUPERUSER', 'ROLE_VALIDATOR'];
        vm.authoritiesNoAdmin = ['ROLE_USER', 'ROLE_MODOP', 'ROLE_SUPERUSER', 'ROLE_VALIDATOR'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
